module.exports = function(app) {
	app.directive('convertToNumber', convertToNumber);
	convertToNumber.$inject=[];
	function convertToNumber() {
		return {
			require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function(val) {
                    return '' + val;
                });
            }
	    }
	}	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/convertToNumber.js
// module id = 438
// module chunks = 0